export default "<p>\n  jinia-template-element works!\n</p>\n";